"use strict";import{IllustratedMessage as e}from"./src/IllustratedMessage.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-illustrated-message",e);
//# sourceMappingURL=sp-illustrated-message.js.map
